/* eslint-disable @typescript-eslint/no-explicit-any */
import axios from "axios";
import { apiConsumer } from ".";
import { Buffer } from "buffer";

export const signFile = async (
  route: string,
  type: string,
  fileName?: string,
): Promise<string> => {
  const { data } = await apiConsumer({
    endpoint: "/tools/sign",
    body: {
      route: `${route}`,
      type,
      file_name: fileName,
    },
    method: "POST",
  });

  return data;
};

export const saveFile = async (url: string, file: File) => {
  const fileData = Buffer.from(await file.arrayBuffer());
  await axios.put(url, fileData, {
    headers: {
      "Content-Type": file.type,
      Accept: "*/*",
    },
      });
  };

export const getSignedDownloadUrl = async (fileUrl: string): Promise<string> => {
  try {
    const response = await apiConsumer({
      endpoint: '/tools/download',
      method: 'POST',
      body: {
        fileUrl: fileUrl,
      },
    });

    if (response.data) {
      return response.data;
    } else {
      throw new Error('Invalid response format');
    }
  } catch (error) {
    console.error('Error getting signed download URL:', error);
    throw error;
  }
};
